/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';

import { StyledTable } from './styles';

interface IProps {
  children: React.ReactNode;
}

interface ITableHeaderSortable {
  children: any;
  array: any;
  field: any;
  onChange: any;
}

const Table = ({ children }: IProps) => {
  return <StyledTable>{children}</StyledTable>;
};

export const TableHeaderSortable = ({
  children,
  array,
  field,
  onChange,
}: ITableHeaderSortable) => {
  const [directionDesc, setDirectionDesc] = useState(false);

  const handleSortBy = () => {
    onChange(
      array.sort((a: any, b: any) =>
        a[field] > b[field] && directionDesc ? 1 : -1,
      ),
    );

    setDirectionDesc(!directionDesc);
  };

  return (
    <span onClick={handleSortBy}>
      {`${children} `}
      {directionDesc ? (
        <MdArrowDropUp size={20} />
      ) : (
        <MdArrowDropDown size={20} />
      )}
    </span>
  );
};

export default Table;
